import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { login, isLoggedIn, message, getSubsite, isNhKLocked } from "../reducers/auth";
import Form from "react-bootstrap/Form";
import * as Yup from 'yup';
import { Formik } from 'formik';
import Button from "react-bootstrap/Button";
import { getCurrentOrder } from "../reducers/cart";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { resolveRetailHomePath } from "../utils/retailHome";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};



const Home = (props) => {
  let apiUrl = process.env.REACT_APP_LOCALHOST_URL;

  let navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const isLoggedInVal = useSelector(isLoggedIn);
  const authMessage = useSelector(message);
  const dispatch = useDispatch();
  const currentOrderStatusVal = useSelector(state => state.cart.currentOrderStatus);
  const currentSubsite = useSelector(getSubsite);
  const nhkLocked = useSelector(isNhKLocked);
  const loginValidationSchema = Yup.object().shape({
    username: Yup.string()
      .required("*Username is required"),
    password: Yup.string()
      .required("*Password is required"),
  });

  
  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };
  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (values, actions) => {
    if(!values.username) return;
    console.log("IN HANDLE LOGIN");
    dispatch(login({username: values.username, password:values.password}));
    console.log(actions);
    actions.setSubmitting(false);
  }

  useEffect(() => {
    console.log("AUTH MESSAGE CHANGED", authMessage);
    setLoading(false);
  }, [authMessage]);

/*  useEffect(() => {
    console.log("IN USE EFFECT", isLoggedInVal);
    if (isLoggedInVal) {
      navigate("/featured");
    }
  }, [isLoggedInVal, navigate]);
*/
  useEffect(() => {
    console.log("HOME", isLoggedInVal);
    if (isLoggedInVal) {
      console.log("DISPATCH GET CURR ORDER");
      dispatch(getCurrentOrder());
      //navigate("/home");
    }
  }, [isLoggedInVal, dispatch]);


  useEffect(() => {
    console.log("IN LOGIN::", currentOrderStatusVal);
    if (currentOrderStatusVal === 'succeeded' && isLoggedInVal) {
      resolveRetailHomePath(currentSubsite, { nhkLocked }).then((path) => navigate(path));
    }
  }, [currentOrderStatusVal, navigate, nhkLocked, isLoggedInVal, currentSubsite]);
  

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
        <div style={{padding: 30}}>
        {process.env.REACT_APP_ENV === 'demo' && 
              <img src={apiUrl + "/img/site/Ignite_logo_full_black_demo.png"} width={"100%"} alt="Ignite Logo" />
            }
            {process.env.REACT_APP_ENV === 'production' && 
              <img src={apiUrl + "/img/site/Ignite_logo_full_black.png"} width={"100%"} alt="Ignite Logo" />
            }
        </div>
          <h1>Welcome to Ignite</h1>
          <p>Ignite is a custom apparel company that specializes in customizing apparel for your business, team, or event.  We offer a wide variety of products and services to meet your needs.  Please login to get started.</p>
        </Col>
        <Col>
        <div className="card card-container">
        <img
            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
            alt="profile-img"
            className="profile-img-card"
          />
        <Formik 
        initialValues={{ }}
        validationSchema={loginValidationSchema}
        onSubmit={handleLogin}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting }) => (
            <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control 
                  name="username"
                  type="text"
                  placeholder="Enter Username"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.username}
                  className={touched.username && errors.username ? "error" : null}
                />
                {touched.username && errors.username ? (
                  <div className="error-message">{errors.username}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control 
                  name="password"
                  type="password"
                  placeholder="Enter Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  className={touched.password && errors.password ? "error" : null}
                />
                {touched.password && errors.password ? (
                  <div className="error-message">{errors.password}</div>
                ): null}
              </Form.Group>
              <Button variant="primary" onClick={handleLogin} type="submit" disabled={isSubmitting}>
                  Login
                </Button>
              {authMessage && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {authMessage}
                </div>
              </div>
             )}
             <br/>
             <br/>
             <a href="/forgotpassword">Forgot Password?</a><br />
             <a href="/contact">Need Help? Contact Us.</a>
             <br/>
             <br/>
             <a href="/requestregistration">Request Registration</a>
     
            </Form>  
      )}
    </Formik>






     
        </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Home;